import React from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import SwiperCore, {
  Pagination,
} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper-bundle.css';

import Container from '@components/Container';
// import videoMask from '@asserts/images/products/video_mask.png';

import { getCustomData } from '@utils/Analysis';
 
const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    color: 'rgba(0, 0, 0, 1)',
    '& > img': {
      width: '100%',
    },
  },
  title: {
    paddingLeft: rem(20),
    fontSize: rem(16),
    lineHeight: rem(24),
  },
  sliderContainer: {
    width: '100%',
    marginBottom: rem(15),
    overflowX: 'hidden',
    '& .swiper-wrapper': {
      height: rem(170),
      boxShadow: '0px 2px 6px 0px rgba(229,229,229,1)',
    },
    '& .swiper-slide': {
      width: '100%',
      overflow: 'hidden',
      height: rem(170),
      borderRadius: 2,
      '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    '& .swiper-pagination': {
      bottom: 0,
      '& .swiper-pagination-bullet': {
        backgroundColor: '#FFF',
      },
      '& .swiper-pagination-bullet-active': {
        backgroundColor: '#007aff',
      },
    },
  },
  sVideo: {
    width: '100%',
    height: '100%',
    margin: '0 auto',
    // objectFit: 'cover',
  },
}), {
  name: 'BrandPage'
})

SwiperCore.use([Pagination]);

// 品牌
const BrandPage = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const { t, data } = props;
  const custom = getCustomData(data);
  const videos = R.pathOr([], ['morevideos'])(custom);

  // 品牌1
  const brandOne = R.pathOr([], ['moreimagestyleone'])(custom);
  // 品牌2
  const brandTwo = R.pathOr([], ['moreimagesstyletwo'])(custom);

  const handleGoBrand = (data) => {
    const link = R.pathOr('', ['styletwolink'])(data);
    if (!link) return;
  }

  const handleGoBrandTwo = (data) => {
    const link = R.pathOr('', ['styletwolink'])(data);
    if (!link) return;
    global.window.location.href = link;
  }

  return (
    <Container className={classNames(classes.root)} id='brand'>
      <h2 className={classes.title} value='brand'>{t('brand')}</h2>
      <Swiper
        loop
        spaceBetween={50}
        pagination={{ clickable: true }}
        className={classNames(classes.sliderContainer)}
      >
        {
          videos.map((item, index) => (
            <SwiperSlide key={String(index)}>
              <video 
                playsInline
                controls='controls'
                src={R.pathOr('', ['filelocation'])(item)}
                // poster={R.pathOr('', ['0', 'styleoneimage', 'filelocation'])(brandOne)}
                // poster={videoMask}
                className={classes.sVideo}
              >
                <source src={R.pathOr('', ['filelocation'])(item)}type="video/mp4" />
              </video>
            </SwiperSlide>
          ))
        }
      </Swiper>
      {
        brandOne && brandOne.map((item, index) => (
          <img 
            key={index} 
            src={R.pathOr('', ['styleoneimage', 'filelocation'])(item)} 
            alt={t('brand')} 
            width={300} 
            style={{ marginBottom: 10 }}
            onClick={() => handleGoBrand(item)}
          />
        ))
      }
      {
        brandTwo && brandTwo.map((item, index) => (
          <img 
            key={index} 
            src={R.pathOr('', ['styletwoimage', 'filelocation'])(item)} 
            alt={t('brand')}
            width={300}
            style={{ marginBottom: 10 }}
            onClick={() => handleGoBrandTwo(item)}
          />
        ))
      }
    </Container>
  )
};

BrandPage.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
}

export default BrandPage;
